import type { ImgHTMLAttributes, ReactNode } from 'react';
import { avatarImageUrl } from '../utils/avatarImage';

type Props = Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'referrerPolicy'> & {
  source?: string | null;
  fallback: ReactNode;
};

/** Resolve an avatar once and consistently apply the safe image/fallback policy. */
export function AvatarImage({ source, fallback, ...props }: Props) {
  const src = avatarImageUrl(source);
  return src ? <img {...props} src={src} referrerPolicy="no-referrer" /> : <>{fallback}</>;
}
